module.exports = __webpack_public_path__ + "img/ball2.d7c78b79.png";